import { Modal } from "react-bootstrap"
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton"

export const ModalContainer = ({ show, onHide, children }) => {
  return (
    <Modal 
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className="modal-investigation"
      enforceFocus={false}
      restoreFocus={false}
    >
      <EGIconButton
        iconName="cancel_circle"
        onClick={onHide}
        iconColor="primary"
        sx={{ position: "absolute", top: 6, right: 6 }}
      />
      {children}
    </Modal>
  )
}